import React from 'react';
import Dialog, { DialogProps } from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '../button';
import { slideTopAndLegacyTransition } from './__fixtures__';

type OmitProps = 'title';

const defaults = {
  confirmLabel: 'OKAY',
};

interface Props extends Omit<DialogProps, OmitProps> {
  title: string;
  onClose: () => void;
  message?: string;
  confirmLabel?: string;
  slideTop?: boolean;
}

const AlertModal: React.FC<Props> = ({
  title,
  onClose,
  message,
  confirmLabel = defaults.confirmLabel,
  slideTop,
  ...props
}) => (
  <Dialog
    {...props}
    {...slideTopAndLegacyTransition(slideTop, false)}
    maxWidth={props.maxWidth ?? 'xs'}
    fullWidth
    open={props.open}
    onClose={onClose}
    disableEnforceFocus
  >
    <DialogTitle sx={{ fontWeight: 700, padding: '16px 24px' }}>{title}</DialogTitle>
    <DialogContent>
      {message && <DialogContentText>{message}</DialogContentText>}
      {props.children}
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} autoFocus>
        {confirmLabel}
      </Button>
    </DialogActions>
  </Dialog>
);

export default AlertModal;
